export default __webpack_public_path__ + "static/media/logoLine.8ed7ef87.webp";